<template>
  <v-card class="angebot-dialog round-corners black87">
    <v-icon v-if="success || error" id="close-icon" @click="$emit('close')">clear</v-icon>

    <v-card-text>
      <template v-if="!success && !error">
        <div class="dialog-text">{{ waitingText }}</div>

        <v-progress-linear indeterminate color="primary"/>
      </template>

      <template v-else-if="success">
        <div class="status-icon">
          <v-icon x-large color="primary">check</v-icon>
        </div>

        <div class="dialog-text">{{ successText }}</div>

        <v-container fluid class="dialog-btn pa-0">
          <v-row justify="center" no-gutters>
            <v-btn color="primary" class="ma-2" @click="$emit('open-angebot')">Jetzt öffnen</v-btn>
            <v-btn
              v-show="reset"
              class="standard-button ma-2"
              @click="$emit('reset-angebot', 'close')"
            >{{ resetButtonText }}</v-btn>
          </v-row>
        </v-container>

        <v-container v-if="saveFor" fluid class="pt-0 pb-4">
          <v-row justify="center" no-gutters>
            In Angebotsliste des Maklers gespeichert
          </v-row>
        </v-container>

        <div class="info-text">
          <div>
            <v-icon color="primary">info_outline</v-icon>
            <span>
              Erstellte Angebote oder Vorschläge werden automatisch unter
              <router-link :to="'/angebote'" target="_blank" color="primary">Kundenverwaltung</router-link> gespeichert.
              <template v-if="(produktinfoLink || hidePib) && arbLink">
                Es gelten <template v-if="!hidePib">das
                <a
                  :href="produktinfoLink"
                  target="_blank"
                  class="primary--text"
                >Produktinformationsblatt</a>
                und </template>die
                <a :href="arbLink" target="_blank" class="primary--text">{{ arbTitle }}</a>.
              </template>
            </span>
          </div>
        </div>
      </template>

      <template v-else>
        <div class="status-icon">
          <v-icon x-large color="error">clear</v-icon>
        </div>

        <div class="dialog-text">{{ errorMessage || errorText }}</div>

        <div class="info-text">Bitte überprüfen Sie Ihre Eingaben.</div>
      </template>
    </v-card-text>
  </v-card>
</template>
<script>
import contentLoadingMixin from "@/components/helper/contentLoadingMixin";

export default {
  mixins: [
    contentLoadingMixin(["ARB", "ARB_SUS", "PI_Standard", "PI_EXPERT", "PI_PRESTIGE", "PI_SUS", "ARB_YOLIG", "PI_YOLIG"])
  ],
  props: {
    title: {
      type: String,
      default: "Antrag"
    },
    success: {
      type: Boolean,
      required: true
    },
    error: {
      type: Boolean,
      required: true
    },
    errorMessage: {
      type: String,
      required: false,
      default: ''
    },
    reset: {
      type: Boolean,
      required: false,
      default: false,
    },
    sus: {
      type: Boolean,
      required: false,
      default: false,
    },
    hidePib: {
      type: Boolean,
      required: false,
      default: false,
    },
    yolig: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  computed: {
    waitingText() {
      switch (this.title) {
        case "Antrag":
          return "Antrag wird übermittelt...";
        case "Kurzangebot":
          return "Vorschlag für Ihren Rechtsschutz wird erstellt...";
        default:
          return "Angebot wird erstellt...";
      }
    },
    saveFor() {
      // vl and 
      // overwrite makler present this.$store.state.b.selectedIdentity.username
      // this.$props.hidePib == false 
      if (this.$props.hidePib == false 
          && (this.$store.state.b.selectedIdentity.username ?? "") != ""
          && this.$store.state.user.authorization.roles.includes('fremdangebot') 
          && this.$store.state.b.fremdangebot ) {
        return true;
      } else {
        return false;
      }
    },
    resetButtonText() {
      switch (this.title) {
        case "Antrag":
          return "Neues Angebbot";
        case "Kurzangebot":
          return "Neuer Vorschlag";
        default:
          return "Neues Angebot";
      }
    },
    successText() {
      switch (this.title) {
        case "Kurzangebot":
          return "Vorschlag für Ihren Rechtsschutz erfolgreich erstellt.";
        default:
          return `${this.title} erfolgreich erstellt.`;
      }
    },
    errorText() {
      switch (this.title) {
        case "Kurzangebot":
          return "Fehler beim Erstellen des Vorschlags für Ihren Rechtsschutz.";
        default:
          return `Fehler beim Erstellen des ${this.title}s.`;
      }
    },
    produktinfoLink() {
      if (!this.PI_Standard || !this.PI_PRESTIGE || !this.PI_EXPERT || !this.PI_SUS)
        return null;
      let url = this.PI_Standard.items[0].link;
      if ( this.sus )
        return this.PI_SUS.items[0].link;
      switch (this.$store.state.b.productLine) {
        case "STD":
          url = this.PI_Standard.items[0].link;
          break;
        case "PRE":
          url = this.PI_PRESTIGE.items[0].link;
          break;
        case "YOLIG":
          url = this.PI_YOLIG.items[0].link;
          break;
        default:
          url = this.PI_EXPERT.items[0].link;
      }
      return url;
    },    
    arbTitle () {
      if(this.sus) {
        return this.ARB_SUS ? this.ARB_SUS.items[0].title : 'ARB Schnell und Sicher';
      } else if(this.yolig) {
        return this.ARB_YOLIG ? this.ARB_YOLIG.items[0].title : 'ARB YOLIG';
      } else {
        return this.ARB ? this.ARB.items[0].title : 'ARB';
      }
    },
    arbLink() {
      if(this.sus){
        return this.ARB_SUS ? this.ARB_SUS.items[0].link : null;
      } else if(this.yolig) {
        return this.ARB_YOLIG ? this.ARB_YOLIG.items[0].link : null;
      } else {
        return this.ARB ? this.ARB.items[0].link : null;
      }
    }
  }
};
</script>
<style>
.angebot-dialog {
  padding: 24px;
  position: relative;
  box-shadow: none !important;
  margin: 0 !important;
}

.angebot-dialog .v-progress-linear {
  margin-bottom: 0;
}

.angebot-dialog .dialog-text {
  text-align: center;
  font-size: 20px;
  width: 100%;
  margin-bottom: 40px;
}

.angebot-dialog .status-icon {
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}

.angebot-dialog .status-icon .v-icon {
  padding: 10px;
  border: solid 2px;
  border-radius: 3px;
}

.angebot-dialog .dialog-btn {
  display: flex;
  justify-content: center;
  margin-bottom: 56px;
}

.angebot-dialog #close-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  color: rgba(0, 0, 0, 0.87);
  cursor: pointer;
}

.angebot-dialog .info-text {
  font-size: 14px;
  display: flex;
  justify-content: center;
}

.angebot-dialog .info-text > div {
  display: flex;
  flex-direction: row;
}

.angebot-dialog .info-text .v-icon {
  margin: 0 8px auto 0;
}
</style>
